import React from "react";
import _ from 'lodash';

import Grid from '@material-ui/core/Grid';
import BRLCurrency from '../Inputs/BRLCurrency';
import Weight from '../Inputs/Weight';
import Distance from '../Inputs/Distance';
import NewButton from '../Buttons/NewButton';
import DeleteButton from '../Buttons/DeleteButton';
import SlotNumber from '../Inputs/SlotNumber';
import Member from '../Inputs/Member';
import Age from '../Inputs/Age';
import SlotType from '../Inputs/SlotType';
import useStyles from './styles';

const SlotGroup = ({state, handleChange, handleAddButton}) => {

  const classes = useStyles();

  return <Grid
    container
    spacing={4}
    className={classes.box}
  >
    {_.map(state,
      (el, idx) => <Slot
        key={idx}
        isDelete={idx !== state.length - 1}
        handleAddButton={handleAddButton(idx)}
        handleChange={handleChange(idx)}
        {...el}
      />
    )}
  </Grid>;
};

export const Slot = ({
  member,
  age,
  value,
  weight,
  distance,
  slotType,
  slotNumber,
  handleChange,
  handleAddButton,
  isDelete,
}) => {

  const classes = useStyles();

  return <Grid
    container
    spacing={4}
    className={classes.content}
  >
    <Grid item xs={12} md={6}>
      <Member
        fullWidth
        required
        value={member}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <Age
        fullWidth
        required
        value={age}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <Weight
        fullWidth
        required
        value={weight}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <Distance
        fullWidth
        required
        value={distance}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <BRLCurrency
        fullWidth
        required
        value={value}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <SlotNumber
        fullWidth
        required
        value={slotNumber}
        onChange={handleChange}
      />
    </Grid>
    <Grid item xs={12} sm={9} md={6}>
      <SlotType
        fullWidth
        required
        value={slotType}
        onChange={handleChange}
      />
    </Grid>
    <Grid item>
      {
        handleAddButton
          ? isDelete
          ? <DeleteButton onClick={handleAddButton}/>
          : <NewButton onClick={handleAddButton}/>
          : null
      }
    </Grid>
  </Grid>;
};

Slot.defaultProps = {
  value: '',
  distance: '',
  weight: '',
  slotType: 'rp1a',
  slotNumber: 6,
  member: '',
  age: ''
};

export default SlotGroup;
